/*
 * Lib Module Templates
 */

Lib.Template = (function() {

    var self = {};

    self.parse = function(name, data, camelizeData, returnAsText) {

        // Get the raw template code
        var rawTemplate = self.getTemplate(name);

        if (camelizeData !== false) {
            if (typeof data === 'object') {
                $.each(data, function(key, value) {
                    data[Lib.String.camelize(key)] = value;
                });
            }
        }

        // Run the parse with raw html
        var result = self.parseRaw(rawTemplate, data);

        // If there is a compiled template
        if (result !== false) {
            return returnAsText ? result : $(result);
        }

        return false;
    };

    /**
     *
     * @param name
     * @returns {void}
     */
    self.templateElement = function(name) {
        var templateEl = $('script[data-template=\'' + name + '\']');
        if (templateEl.length === 0) {
            return Lib.Debug.warn('Cant find template ' + name);
        }
        return templateEl;
    };

    /**
     *
     * @param name
     */
    self.getTemplate = function(name) {

        return self.templateElement(name).html();
    };

    /**
     *
     * @param template
     * @param data
     * @returns {*}
     */
    self.parseRaw = function(template, data) {
        var compiledTemplate = self.compile(template);
        if (typeof compiledTemplate === 'function') {
            return compiledTemplate(data);
        }
        return false;
    };

    /**
     *
     * @param template
     */
    self.compile = function(template) {
        return Handlebars.compile(template);
    };

    return self;

})();
